import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/empty_state.svg'


const _hoisted_1 = { class: "w-full h-full flex items-center justify-center flex-col space-y-4" }
const _hoisted_2 = { class: "text-md font-medium" }
const _hoisted_3 = { class: "text-darkgrey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-primarylight w-96 h-96 rounded-full flex items-center justify-center" }, [
      _createElementVNode("img", {
        width: "250",
        src: _imports_0,
        alt: "Empty state image"
      })
    ], -1)),
    _createElementVNode("h3", _hoisted_2, "No added " + _toDisplayString(_ctx.pageName) + " yet!", 1),
    _createElementVNode("h4", _hoisted_3, "This section will contain the list of " + _toDisplayString(_ctx.pageName) + ".", 1),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}